import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { triggerDashboardAudit } from "../../redux/actions";
import { useSelector } from "react-redux";

/**
 * @description Renders dashboard card component
 * @version 0.0.1
 * @param {number} props.index - key for individual card
 * @param {string} props.id - serves as url to be redirected to
 * @param {string} props.text - text to be displayed on card
 *
 * @component
 *
 * @example
 * const props= {
 *  index: 1,
 *  id: '/partneranalytics/pcredirect/deviceSales',
 *  text: 'Device Sales'
 * }
 * return(
 *  <DashboardCard props={props} />
 * )
 */
export const DashboardCard = (props) => {
  const { filterValue } = useSelector((state) => state.homeReducer);

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "open",
        dashboard: props.text?.name ?? props.text,
        empId: filterValue?.agentId?.length
          ? filterValue?.agentId
          : filterValue?.orgId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: "",
      },
    };
    triggerDashboardAudit(obj);
  };

  return (
    <>
      <div className="col-md-3" key={props.index} onClick={sendAudit}>
        <div
          className="whitebox  wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
        >
          <Link to={props.id}>
            <div
              className={`circle simcir0${props.index + 1}`}
              style={{ background: "#03007f" }}
            >
              {props.icon ? (
                <i
                  className={`${props.icon}`}
                  style={{ transform: "scale(2)", color: "white" }}
                ></i>
              ) : (
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `/assets/images/sim-act-icon/ActivationPayout.png`
                  }
                  alt=""
                />
              )}
            </div>
          </Link>

          <div className="acti-title" data-cy="module-tile">
            {props.text}
          </div>
        </div>
      </div>
    </>
  );
};

DashboardCard.propTypes = {
  /**
   * Dashboard card index
   */
  index: PropTypes.number,
  /**
   * Dashboard card url
   */
  id: PropTypes.string,
  /**
   * Dashboard card text
   */
  text: PropTypes.string,
};

DashboardCard.defaultProps = {
  index: 1,
  id: "/partneranalytics/pcredirect/deviceSales",
  text: "Device Sales",
};
